import classes from "./Card.module.scss";

interface ICardPros {
  children: JSX.Element | JSX.Element[];
  onClickFunction: any;
  selected?: boolean;
  disabled?: boolean;
}

const Card = (props: ICardPros) => {
  const { children, onClickFunction, selected, disabled } = props;
  return (
    <div
      className={
        classes[
          `main-frame-wrapper${selected ? "__selected" : ""}${
            disabled ? "__disabled" : ""
          }`
        ]
      }
    >
      <div
        className={classes.content}
        onClick={!disabled ? onClickFunction : undefined}
      >
        {children}
      </div>
    </div>
  );
};

export default Card;
